// eslint-disable-next-line import/prefer-default-export
export const ADD_RIDE_CARD_SETTINGS = 'ADD_RIDE_CARD_SETTINGS';
export const ADD_LIST_COLUMNS_SETTINGS = 'ADD_LIST_COLUMNS_SETTINGS';
export const SET_VISIBILITY_OF_SETTINGS_DIALOG = 'SET_VISIBILITY_OF_SETTINGS_DIALOG';
